import React from 'react'
import { SalesDeckRenderer } from '../components/sales/SalesDeckRenderer'
import { InteractiveSalesDeck } from '../components/sales/InteractiveSalesDeck'
import { SeoHead } from '../components/landing/SeoHead'
import { siteOrigin } from '../components/landing/marketingPages'
import { salesDeckBySlug } from '../content/salesDecks'

type SalesDeckPageProps = {
  slug: string
}

export const SalesDeckPage: React.FC<SalesDeckPageProps> = ({ slug }) => {
  const seo = (
    <SeoHead
      title="NexusWorkforce360 Sales Deck"
      description="Internal NexusWorkforce360 sales deck."
      canonicalUrl={`${siteOrigin}/sales-decks/${slug}`}
      noindex
    />
  )

  // Handle interactive deck separately
  if (slug.toLowerCase() === 'interactive') {
    return <>{seo}<InteractiveSalesDeck /></>
  }

  const deck = salesDeckBySlug.get(slug)

  if (!deck) {
    return (
      <div className="sales-deck-page">
        {seo}
        <main className="sales-deck-main">
          <section className="sales-deck-empty">
            <p className="sales-deck-kicker">Sales decks</p>
            <h1>Deck not found</h1>
            <p>Choose one of the available NexusWorkforce360 sales decks.</p>
            <a className="btn btn-primary" href="/sales-decks">Open sales deck index</a>
          </section>
        </main>
      </div>
    )
  }

  return <>{seo}<SalesDeckRenderer deck={deck} /></>
}
